import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { getSelectedProject } from '../../redux/projects/actions';
import icons from '../../assets/icons';
import API from '../../services/api';

import './styles.scss';

const StatusBar = ({ lastUpdated }) => {
  const [status, setStatus] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const project = useSelector(getSelectedProject);

  useEffect(() => {
    calculateStatus();
  }, [lastUpdated, project]);

  const calculateStatus = () => {
    if (project) {
      setStatus({});
      setIsLoading(true);
      API.getSiteGroupStats(project.id)
        .then(response => {
          const status = response.deviceCountByStatus;
          setStatus({
            online: status.detecting,
            offline: status.offline,
            stopped: status.inactive + status.downloadingModels + status.noCamera
          });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="status-counters">
      <div className="status-counter">
        <span className="status-counter-icon">
          <img src={icons.online} alt="" />
        </span>
        <span className="status-counter-label">Online</span>
        <b>{isLoading ? '--' : status.online}</b>
      </div>
      <div className="status-counter">
        <span className="status-counter-icon">
          <img src={icons.offline} alt="" />
        </span>
        <span className="status-counter-label">Offline</span>
        <b>{isLoading ? '--' : status.offline}</b>
      </div>
      <div className="status-counter">
        <span className="status-counter-icon">
          <img src={icons.stopped} alt="" />
        </span>
        <span className="status-counter-label">Stopped</span>
        <b>{isLoading ? '--' : status.stopped}</b>
      </div>
    </div>
  );
};

export default StatusBar;
